<script>
import {generateUUID, percentage_format, numberWithCommas} from "@/utils.js";
import moment from "moment";
import baselinesData from "@/data/baselinesData.json";
import MarketingRecommendations from "@/view/components/campaign_analytics/MarketingRecommendations.vue";

import {
  getAnalyticsPosMetricAvg,
  getAnalyticsKPIMetricAvg,
  getAnalyticsRegionMetricAvg,  
  getTotalSalesYoY,
  getDailyTotalSalesYoY,
  getTotalSalesCampaignAnalytics
} from "@/api/analytics";
export default {
  name: "kpi-metric",
  props: [
    "form",  
    "isNetworkData",
    "disabledInAbsoluteValue",
    "campaignIsSearch",
    "marketing_recommendations",
    "timeDimention"
  ],
  components: {
    MarketingRecommendations
  },
  data() {
    return {
      options: {},
      series: [],
      result: [],
      temp_dates: [],
      dates: [],
      hasData: false,
      baselines: baselinesData,
      campaign_start: "",
      campaign_end: "",
      formkpi: {
        selectedKPIMetric : 'sales',
        selectedYearOver: 1,
      },
      overYearOption: [
        { text: "Year over Year", value: 1 },
        { text: "Year over 2 Years", value: 2},
        { text: "Pre&Post Net of Control", value: 'ppnoc'},
        // { text: "Hi Fi (Highest Fidelity)", value: 'hifi', desc: 'This is our most confident statistical approach'}
      ],
      KPIMetricOptions : [
        { text: "Sales", value: 'sales'},
        { text: "Traffic", value: 'traffic'},
        { text: "Average Check", value: 'average_check'},
        { text: "Frequency", value: 'frequency'},
        { text: "Recency", value: 'recency'},
      ],
      isSearch: false,
      pos_metrics : [],
      region_metrics : [],
      total_sales_yoy_data : [],
      campaign_start_total_sales:[],
      campaign_end_total_sales:[],
      yoyCategoryView: "These values are reported in Year over Year changes",
      legendSelectors:Array.from({length: baselinesData.length+1}, (v, i) => true),
      graphColor:{
        color1:"#E91E63",
        color2: "#2E93fA",
        color3:"#FFFF00",
        color4:"#66DA26",
        color5:"#FF9800",
        color6:"#546E7A"
      },
      kpimetricDate:[],
      addCampaignStartDate:false,
      addCampaignEndDate:false
    };
  },
  mounted(){
  },
  computed: {
    chartId() {
      return `chart_${generateUUID()}`;
    }
  }, 
  watch: {
    formkpi: {
      handler(data) {
        this.$emit('watchOverYear', data.selectedYearOver)
      },
      deep: true
    },
    isNetworkData() {
      this.onSearch();
    },
    "disabledInAbsoluteValue"(){
      if(this.disabledInAbsoluteValue){
        this.fetchData()
      }
    }
  },
  methods: {
    calculateCampaignDatesData(){
      for(let i=0;i<this.series.length;i++){
        let campaign_start_index = this.series[i]['data'].findIndex(data => data.x ===moment(this.form.campaign.date_start).format("YYYY-MM-DD"));
        let campaign_end_index = this.series[i]['data'].findIndex(data => data.x ===moment(this.form.campaign.date_ended).format("YYYY-MM-DD"));
        // console.log("Campaign start index, campaign end index:",campaign_start_index,campaign_end_index)
        let value_after_campaign_start = 0
        let value_after_campaign_end = 0
        let value_before_campaign_start = this.series[i]['data'][campaign_start_index-1].y

        if (campaign_start_index + 1 < this.series[i].data.length) {
          value_after_campaign_start = this.series[i]['data'][campaign_start_index+1].y
        }
        if (campaign_end_index + 1 < this.series[i].data.length) {
          value_after_campaign_end = this.series[i]['data'][campaign_end_index+1].y
        }
       
        if (this.addCampaignStartDate ){
          this.series[i]['data'][campaign_start_index]['y'] = (value_before_campaign_start+value_after_campaign_start)/2;
        }

        let value_before_campaign_end = this.series[i]['data'][campaign_end_index-1].y
        if (this.addCampaignEndDate ){
          this.series[i]['data'][campaign_end_index]['y'] = (value_before_campaign_end+value_after_campaign_end)/2;
        }
      }
    },
    filterTotalSalesData() {
      let dates = this.total_sales_yoy_data.map(item => item.date);
      // Filter dates
      dates = dates.filter((v, i, a) => a.indexOf(v) === i);
      // for (let i = 0; i < dates.length; i++) {
      //   let date = dates[i];
      //   if (this.temp_dates.indexOf(date) === -1) {
      //     this.temp_dates.push(date);
      //   }
      // }
      let data = [];
      let temp_dates = this.temp_dates.sort();
      for (let i = 0; i < temp_dates.length; i++) {
        let date = temp_dates[i];
        data.push(moment(date).format("YYYY-MM-DD"));
      }
      data = data.sort();
      this.dates = data;
    },
    async fetchData() {
      try {
        this.series = [];
        this.kpimetricDate = []
        
        this.isSearch = true;
        if (this.formkpi.selectedYearOver === 3){ // when absolute value then reset and no value return
          this.series = [];
          this.calculateCampaignDatesData();
          this.setChartOptions();
          setTimeout(() => {
            this.isSearch = false;
          }, 1000);
          return true
        }
        // console.log("1",this.legendSelectors)
        this.legendSelectors = Array.from({length: baselinesData.length+1}, (v, i) => true);

        ///benchmark/analytics/kpi/avg  OR /benchmark/analytics/pos/sales/avg
        //benchmark/weekly-total-sales-campaign-analytics
        ///benchmark/daily-total-sales-yoy OR benchmark/daily-total-sales-yo2y
        const payload = JSON.parse(
          JSON.stringify({
            // pos_id: this.form.location.value,
            pos_id:null,
            start_date: this.form.dtpicker.start,
            end_date: this.form.dtpicker.end,
            campaign_id: this.form.campaign.id,
            period: "day",
            location_ids: this.form.location_ids
          })
        );
        

        let campaign_start = moment(this.form.campaign.date_start).format(
          "YYYY-MM-DD"
        );
        let campaign_end = moment(this.form.campaign.date_ended).format(
          "YYYY-MM-DD"
        );
        const responses = await Promise.all([
          getAnalyticsKPIMetricAvg(payload, this.formkpi.selectedYearOver),
          // getAnalyticsRegionMetricAvg(payload),
          // getTotalSalesYoY(payload, this.form.selectedYearOver),
          getTotalSalesCampaignAnalytics(payload, this.formkpi.selectedYearOver),
          getDailyTotalSalesYoY({
            // pos_id: this.form.location.value,
            // pos_id: null,
            start_date: campaign_start,
            end_date: campaign_start,
            campaign_id: this.form.campaign.id,
          }, this.formkpi.selectedYearOver),
          getDailyTotalSalesYoY({
            // pos_id: this.form.location.value,
            // pos_id: null,
            start_date: campaign_end,
            end_date: campaign_end,
            campaign_id: this.form.campaign.id,
          }, this.formkpi.selectedYearOver)
        ]);
        
        if (responses[0] && responses[0].length){
          for (let i = 0; i < responses[0].length; i++) {
            responses[0][i].date = (moment(responses[0][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
          for (let i = 0; i < responses[1].length; i++) {
              responses[1][i].date = (moment(responses[1][i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
          }
          
          this.pos_metrics = responses[0];
          // this.region_metrics = responses[1];
          this.total_sales_yoy_data = responses[1];
          
          this.campaign_start_total_sales = responses[2];
          this.campaign_end_total_sales = responses[3];

          // console.log("pos_metric",this.pos_metric)
          this.result = [];    
          // let result = [...this.pos_metrics, ...this.region_metrics];    
          let result = [...this.pos_metrics];    
          this.result = result;
          // console.log("result",result,this.total_sales_yoy_data);
          this.kpimetricDate = this.result.map(item => item.date);
          // Filter dates
          this.kpimetricDate = this.kpimetricDate.filter((v, i, a) => a.indexOf(v) === i);    
          campaign_start = moment(this.form.campaign.date_start).format("MMM-DD-YYYY");
          campaign_end = moment(this.form.campaign.date_ended).format("MMM-DD-YYYY");
          let campaign_start_temp = moment(this.form.campaign.date_start).format("YYYY-MM-DD");

          let dates = this.total_sales_yoy_data.map(item => item.date);
          if (!this.kpimetricDate.includes(campaign_start_temp) && !dates.includes(campaign_start_temp)) {
            this.kpimetricDate.push(campaign_start_temp.toString()); 
            this.addCampaignStartDate = true;      
          }
          let campaign_end_temp = moment(this.form.campaign.date_ended).format("YYYY-MM-DD");
          if (!this.kpimetricDate.includes(campaign_end_temp) && !dates.includes(campaign_end_temp)) {
            this.kpimetricDate.push(campaign_end_temp.toString());  
            this.addCampaignEndDate = true;      
          }

          this.campaign_start = campaign_start.toString();
          this.campaign_end = campaign_end.toString();
          this.kpimetricDate = this.kpimetricDate.sort();
          this.temp_dates = this.kpimetricDate;
          this.filterTotalSalesData();
          this.$nextTick(() => { 
              this.onSearch();
          })
          this.isSearch = false;
          this.formkpi.selectedKPIMetric = this.KPIMetricOptions[0];
        }
        this.isSearch = false;
      } catch (error) {
        console.log('-------- KPI error: ', error)
        this.isSearch = false;
      }
      
    },
    onSearch() {
      let current_option = "Sales";
      //let current_option = "Traffic";
      let series = [];
      if (this.result && this.result.length > 0) {
        if(this.formkpi.selectedYearOver == 'ppnoc'){
          let baselinePpnoc = {
            "text": "Control ",
            "value": "avg",
            "description": " Average of industry, compset and segment"
            }
          series.push({
            name: baselinePpnoc.text.concat(" ",current_option),// ppnoc fetch only 
            data: this.getData(baselinePpnoc) // pass to asses EACH line
          });
          if(this.isNetworkData){
            baselinePpnoc = {
              "text": "Self ",
              "value": "self",
              "description": "category are restaurants in the same category as your location in your local market. Your local market is defined as an 8-minute drive around your location, and segment is defined by check averages as quick service (&#60;$12), casual dining ($12 - $50), or fine dining (> $50)."
            }
            series.push({
              name: (baselinePpnoc.text === "Self ") ? "My Sales" :  baselinePpnoc.text.concat(" ",current_option),//Rename Self Sales to My Sales
              data: this.getData(baselinePpnoc)
            });
          }
        }else{
          for (let i = 0; i < this.baselines.length; i++) {
            let baseline = this.baselines[i];
            if (baseline.text === "Self " && this.isNetworkData == false){//Skip Self Sales
              continue;
            }
            series.push({
              name: (baseline.text === "Self") ? "My Sales" :  baseline.text.concat(" ",current_option),//Rename Self Sales to My Sales
              data: this.getData(baseline)
            });
            
          }
        }
        
      }
      if(this.isNetworkData){
        this.setChartOptions();
        this.series = series;  
        this.calculateCampaignDatesData();
      } else {
        this.$nextTick(() => { 
            this.setTotalSalesSeries(series); 
        })
      }
    },
    setTotalSalesSeries(series) {
      this.series = [];
      let temp_series = series;
      let data = [];
      for (let i = 0; i < this.dates.length; i++) {
        let d = this.dates[i];
        let total = 0;
        let filter_results = this.total_sales_yoy_data.filter(
            obj => obj.date == d
        );
        // console.log('---- FILTER result: ',filter_results)
        for (let j = 0; j < filter_results.length; j++) {
          let item = filter_results[j];
          total = total + (item.value ? parseFloat(item.value) : 0);
        }
        // data.push(total);
        if (d == this.campaign_start) {
          let campaign_start_value =
              this.campaign_start_total_sales &&
              this.campaign_start_total_sales.length == 1 &&
              this.campaign_start_total_sales[0].value
                  ? parseFloat(this.campaign_start_total_sales[0].value)
                  : 0;
          total = total + campaign_start_value;
        }   

        if (d == this.campaign_end) {
          let campaign_end_value =
              this.campaign_end_total_sales &&
              this.campaign_end_total_sales.length == 1 &&
              this.campaign_end_total_sales[0].value
                  ? parseFloat(this.campaign_end_total_sales[0].value)
                  : 0;
          total = total + campaign_end_value;
        }

        total = (filter_results && filter_results.length ? total/filter_results.length : 0);

        data.push({
          x: d,
          y: total
        });
      }
      temp_series.push({
        name: "My Sales",
        data: data
      });
      console.log()
      this.setChartOptions();
      this.series = temp_series;
      this.calculateCampaignDatesData();
    },
    getData(baseline) {
      let data = [];
      for (let x = 0; x < this.dates.length; x++) {
        let total_sales = 0;
        let d = this.dates[x];
        let filter_results = this.result.filter(
            obj => obj.baseline === baseline.value && obj.date === d
        );
        let sales = 0;
        if (filter_results && filter_results.length) {
          sales = filter_results
              .map(item =>
                  ( !isNaN(parseFloat(item.sales_yoy_avg)) || item.sales_yoy_avg != null) ? parseFloat(item.sales_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        total_sales = total_sales + (sales*100);
        data.push({
          x: d,
          y: total_sales/100
        });
      }
      return data;
    },
    handleKPIMetricChanges(){
      let current_selected_kpi_value = this.formkpi.selectedKPIMetric.value;
      let baseline_append_metric = this.KPIMetricOptions[0].text
      if (current_selected_kpi_value === this.KPIMetricOptions[1].value){
        baseline_append_metric = this.KPIMetricOptions[1].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[2].value){
        baseline_append_metric = this.KPIMetricOptions[2].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[3].value){
        baseline_append_metric = this.KPIMetricOptions[3].text;
      }
      else if (current_selected_kpi_value === this.KPIMetricOptions[4].value){
        baseline_append_metric = this.KPIMetricOptions[4].text;
      }
      
      let series = [];
      if (this.result && this.result.length > 0) {
        if(this.formkpi.selectedYearOver == 'ppnoc'){
          let baselinePpnoc = {
            "text": "Control ",
            "value": "avg",
            "description": " Average of industry, compset and segment"
          }
          series.push({
            // name: baseline.text.concat(" ",baseline_append_metric),
            name: baselinePpnoc.text.concat(" ",baseline_append_metric),// self is skip from if condition above
            data: this.getDatabyKPIMetric(baselinePpnoc,current_selected_kpi_value)
          });
          baselinePpnoc = {
            "text": "Self ",
            "value": "self",
            "description": "category are restaurants in the same category as your location in your local market. Your local market is defined as an 8-minute drive around your location, and segment is defined by check averages as quick service (&#60;$12), casual dining ($12 - $50), or fine dining (> $50)."
          }
          if ((current_selected_kpi_value != this.KPIMetricOptions[0].value && !this.isNetworkData && baselinePpnoc.text === "Self ") || this.isNetworkData){//Skip Self Sales if OFF network and show if ON network
            series.push({
              name: baselinePpnoc.text.concat(" ",baseline_append_metric),// self is skip from if condition above
              data: this.getDatabyKPIMetric(baselinePpnoc,current_selected_kpi_value)
            });
          }
        }else{
          for (let i = 0; i < this.baselines.length; i++) {
            let baseline = this.baselines[i];
            if (current_selected_kpi_value == this.KPIMetricOptions[0].value && !this.isNetworkData && baseline.text === "Self "){//Skip Self Sales 
              continue;
            }
            series.push({
              // name: baseline.text.concat(" ",baseline_append_metric),
              name: baseline.text.concat(" ",baseline_append_metric),// self is skip from if condition above
              data: this.getDatabyKPIMetric(baseline,current_selected_kpi_value)
            });
          }
        }
      }
      if (current_selected_kpi_value == this.KPIMetricOptions[0].value && !this.isNetworkData ){
        this.setTotalSalesSeries(series);
      }
      else{
        this.setChartOptions();
        this.series = series;
        this.calculateCampaignDatesData();
      }
  
    },
    getDatabyKPIMetric(baseline,current_selected_kpi_value) {
      this.legendSelectors = Array.from({length: baselinesData.length+1}, (v, i) => true);
      let data = [];
      
      for (let x = 0; x < this.dates.length; x++) {
        let total_sales = 0;
        let d = this.dates[x];
        let filter_results = this.result.filter(
            obj => obj.baseline === baseline.value && obj.date === d
        );
        let sales = 0;
        if (filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[0].value) {
          sales = filter_results
              .map(item =>
                  (item.sales_yoy_avg !== "NaN" || item.sales_yoy_avg !== null)  ? parseFloat(item.sales_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[1].value) {
          sales = filter_results
              .map(item =>
                  item.traffic_yoy_avg !== "NaN" ? parseFloat(item.traffic_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[2].value) {
          sales = filter_results
              .map(item =>
                  item.average_check_yoy_avg !== "NaN" ? parseFloat(item.average_check_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[3].value) {
          sales = filter_results
              .map(item =>
                  item.frequency_yoy_avg !== "NaN" ? parseFloat(item.frequency_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        else if(filter_results && filter_results.length && current_selected_kpi_value == this.KPIMetricOptions[4].value) {
          sales = filter_results
              .map(item =>
                  item.recency_yoy_avg !== "NaN" ? parseFloat(item.recency_yoy_avg) : 0
              )
              .reduce(x => x);
        }
        total_sales = total_sales + (sales*100);
        data.push({
          x: d,
          y: total_sales/100
        });
      }
      return data;
    },
    togglegendSelector(chartContext, seriesIndex, config){
      // console.log("tog",seriesIndex);
      // console.log("Before toggle",this.legendSelectors);
      this.legendSelectors[seriesIndex] = !this.legendSelectors[seriesIndex];
      // console.log("After toggle",this.legendSelectors);
      // console.log("len",this.baselines.length,this.baselines);
      if(seriesIndex < this.baselines.length){ // To avoid reload on total sales toggle
        let legendSelectorsPayload = [];
        let payload = {};
        for (let i = 0; i < this.baselines.length; i++) {          
          payload[this.baselines[i].value]=this.legendSelectors[i];          
        }
        legendSelectorsPayload.push(payload);
        
        this.$emit('legendSelectors', legendSelectorsPayload);
      }
      
    },
    setChartOptions() {
      let yearOver = this.formkpi.selectedYearOver
      let yaxisLabel= {
        show: false,
        formatter: function (val) {
          if (val === 0 || val === null) {
            return '0%';
          } else {
            return `${percentage_format(val)}`;
          }
        }
      }

      if (yearOver == 'ppnoc') { 
        yaxisLabel= {
          show: false,
          formatter: function (val) {
            return '$' + val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") 
          }
        }
      }

      this.options = {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: true,
            tools: {
              download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
              customIcons: []
            }
          },          
          
        },
        colors: [
          "#E91E63",
          "#2E93fA",
          "#FFFF00",
          "#66DA26",
          "#FF9800",
          "#546E7A"
        ],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        title: {
          text: `Campaign Started ${this.campaign_start} to ${this.campaign_end}`,
          align: "left"
        },
        xaxis: {
          type: "datetime",
          labels: {
              formatter: function (value, timestamp) {
                // value = moment(value).add(6, 'days')
                return moment(value).format('MMM-DD-YYYY')
              } 
          },
        },
        yaxis: {
          show: true,
          showAlways: true,
          labels: yaxisLabel

        },
        tooltip: {
          x: {
            format: "dd/MM/yy",
            show: true
          },
          marker: {
            show: true
          }
        },
        annotations: {
          xaxis: [
            {
              x: this.campaign_start,
              x2: this.campaign_end,
              fillColor: "#333333",
              label: {
                style: {
                  color: "#fff",
                  background: "#333333"
                },
                orientation: "horizontal",
                text: "Campaign Range"
              }
            }
          ]
        }
      };
    }
    
    
  }
};
</script>

<template>
  <div class="kpi-metric-div">
    <div class="dd-div">
      <div class="mr-2 dropdown-select">
        <v-select
          v-model="formkpi.selectedYearOver"
          :items="overYearOption"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        >
        <!-- { text: "Year over Year", value: 1, desc: ''}, -->
          <template v-slot:item="{ item }">
              <v-list-item-content>
                <div class="btn-group" role="group" >
                  <v-list-item-title class="non-mod" v-if="item.desc == null" v-text="item.text"></v-list-item-title>
                  <v-tooltip class="pmod" color="black" bottom v-if="item.desc != null">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-title
                        class="mod"
                        v-bind="attrs"
                        v-on="on"
                        >
                        {{item.text}}
                      </v-list-item-title>
                    </template>
                    <span class="mod-span">{{item.desc}}</span>
                  </v-tooltip>
                </div>
              </v-list-item-content>
            </template>
        </v-select>
      </div>
      <div class="ml-3 dropdown-select">
        <v-select
          v-model="formkpi.selectedKPIMetric"
          :items="KPIMetricOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"  
          width ="50"          
          :menu-props="{ top: false, offsetY: true }"
          return-object
          @change="handleKPIMetricChanges"
          :disabled="this.disabledInAbsoluteValue"
        >
        </v-select>          
      </div>
    </div>
    <div>
      <marketing-recommendations  
        :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
        active_tab="local-market"
        :isNetworkData="isNetworkData"
        :campaignIsSearch="campaignIsSearch"
        :disabledInAbsoluteValue="disabledInAbsoluteValue"
        :form="form"  
        :marketing_recommendations="marketing_recommendations"
        :timeDimention="timeDimention"
      ></marketing-recommendations>

    </div>
    
    <!-- <v-card elevation="3" class="mt-10"> -->
    <v-card class="v-card-marketing">
      <!-- <v-row class="justify-content-between" v-if="this.isSearch"> -->
      <v-row class="justify-space-between zindex-99" >
        <v-col class="mt-3 ml-3">
          <v-alert outlined type="info" text class="outer-container" width="500">
          <span v-if="this.formkpi.selectedYearOver === 1 || this.formkpi.selectedYearOver == 'ppnoc' || this.formkpi.selectedYearOver == 'hifi'">These values are reported in year over year changes</span>
          <span v-if="this.formkpi.selectedYearOver === 2">These values are reported in year over 2 year changes</span>
          <span v-if="this.formkpi.selectedYearOver === 3">No data for absolute values</span>
          </v-alert>
        </v-col>
      </v-row>
      <v-container fluid v-if="isSearch">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-container>
      <!-- v-if="!this.disabledInAbsoluteValue" -->
      <apexchart
          :options="options"
          :series="series"
          type="area"
          height="300"
          :id="chartId"
          @legendClick="togglegendSelector"
      ></apexchart>
    </v-card>
  </div>
</template>
<style>
  .kpi-metric-div .dropdown-select{
    max-width: 200px;
    display: inline-block;
  }
  .v-item--active .local-market-accord .dd-div{
    top: 10px;
    position: absolute;
    right: 70px;
  }
  .zindex-99{
    position: relative;
    z-index: 10;
  }
  .v-card-marketing.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none !important;
  }
</style>
